export default {
  login_register: 'Logga in/Registrera',
  booking_confirmation_title: 'Bokningsbekräftelse',
  booking_confirmation_body: 'Tack för din bokning. Du hittar bekräftelseuppgifter nedan.',
  insurance_requirements_modal_disclaimer: `Genom att göra denna bokning, bekräftar jag att: Jag har inte haft några övertygelser eller bilbrott under de senaste fem åren. Jag har inte fått ett förslag att avvisas, en policy som har avbrutits eller förnyelse vägrats eller varit skyldig att betala en ökad premie eller hade några särskilda villkor som ställts av någon bilförsäkringsgivare. Jag har inte diskvalificerats från att köra. Jag har inte en åtal eller polisutredning i väntan. Jag har inga domar för brott som rör stöld, bedrägeri eller oärlighet inom de senaste fem åren. Jag har inte drabbats av defekt syn eller hörsel (inte korrigerat med glasögon eller hörapparat), hjärtsjukdomar, diabetes, passform eller någon fysisk eller psykisk sjukdom av något slag. Jag har inte haft några olyckor de senaste 5 åren. Klicka {0} om du inte uppfyller dessa krav`,
  insurance_requirements_here: 'här',
  insurance_requirements: `Jag har läst och håller med om att jag {0}`,
  ir: 'Uppfyller Försäkringskraven',
  location: 'Plats',
  pickup_location: 'Hämtningsplats',
  dropoff_location: 'Lämningsplats',
  vehicle: 'Fordon',
  pickup_and_dropoff: 'Hämtning och lämning (lokal tid)',
  distance_allowance: 'Avståndsbidrag',
  view_voucher: 'Visa kupong',
  view_more_bookings: 'Visa fler bokningar',
  identity_verification_body: 'Du måste verifiera din identitet innan du löser in fordonet',
  identity_verification_title: 'Verifiera identitet',
  search_again: 'Sök igen',
  aircon: 'Luftkonditionering',
  refrigeration: 'Kallt',
  not_available: 'Just nu är Drive & Go bara tillgängligt för de som har id- och körkortshandlingar från &amp;, men vi lägger till fler länder hela tiden.',
  check_if_included: 'Se om ditt land finns med.',
  included_in_booking: 'Ingår i bokningen',
  cdw_with_excess: 'Självriskeliminering',
  theft_protection: 'Stöldskyddseliminering',
  risk_reduction: 'Riskreducering',
  free_extras: 'Du kan få två bonusar med den här bokningen',
  total_cost: 'Total hyreskostnad',
  continue: 'Fortsätt',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'stor',
  luggage_medium_long_label: 'medel',
  luggage_small_long_label: 'liten',
  fuel_unspecified_label: 'ospecificerad',
  transmission_manual_label: 'manual',
  transmission_automatic_label: 'automat',
  make_a_booking: 'Boka',
  pickup_date: 'Hämtningsdatum',
  dropoff_date: 'Lämningsdatum',
  driver_age: 'Förare mellan 30 och 65',
  enter_driver_age: 'Ange förarens ålder',
  promo_code: 'Kampanjkod',
  search: 'Sök igen',
  dropoff_date_cannot_be_before_pickup_date: 'Lämningsdatumet kan inte vara före hämtningsdatumet',
  pickup_date_cannot_be_in_the_past: 'Hämtningsdatumet kan inte ha passerat',
  pickup_time_cannot_be_in_the_past: 'Hämtningstiden kan inte ha passerat',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Lämningstiden måste vara senare än hämtningstiden om datumet är samma',
  vehicle_filters: 'Fordonsfilter',
  reset: 'Återställ',
  transmission: 'Växling',
  all: 'Alla',
  manual: 'Manual',
  auto: 'Automat',
  passengers: 'Passagerare',
  vehicle_type: 'Fordonstyp',
  filter: 'Filtrera',
  vehicle_search: 'Fordonssökning',
  edit: 'Redigera',
  no_results: 'Inga resultat uppfyller filtreringskraven.',
  small_cars: 'Små bilar',
  medium_cars: 'Medelstora bilar',
  large_cars: 'Stora bilar',
  estate_cars: 'Kombibilar',
  suvs: 'Stadsjeepar',
  mpvs: 'Minibussar',
  vans: 'Skåpbilar',
  camper_vans: 'Husbilar',
  premium: 'Premium',
  unspecified: 'ospecificerad',
  large: 'stor',
  medium: 'medel',
  small: 'liten',
  automatic: 'automat',
  you_have_been_refunded: 'Du har blivit återbetalad.',
  please_customer_service: 'Kontakta kundtjänst för att boka.',
  contact_customer_service: 'Kontakta kundtjänst',
  booking_failed: 'Din bokning kunde inte behandlas.',
  summary: 'Sammanfattning',
  reforestation_and_protection: 'Stöd återplantering och regnskogsskydd i Costa Rica',
  cost_of_rental: 'Hyreskostnad',
  to_pay_now: 'Att betala nu',
  greenheart_donation: 'Greenheart-donation',
  tc_agreement: 'Jag har läst och förstått {0}.',
  tc: 'Allmänna Villkor',
  receive_offers: 'Jag vill ta emot specialerbjudanden via e-post.',
  donate: 'Ja, jag vill skänka {amount}',
  pay_now: 'Betala {amount} nu',
  driver_details: 'Föraruppgifter',
  complete_driver_details: 'Fyll i föraruppgifterna.',
  are_you_the_driver: 'Är du föraren?',
  have_an_account: 'Har du redan ett konto?',
  login: 'Logga in',
  or: 'eller',
  first_name: 'Förarens förnamn',
  last_name: 'Förarens efternamn',
  email: 'E-postadress',
  phone_number: 'Mobiltelefonnummer',
  unable_to_save_driver_information: 'Det gick inte att spara föraruppgifterna. Försök igen.',
  pay_on_arrival: 'Betala vid ankomst',
  pay_online_now: 'Betala online nu',
  day: 'Dag',
  choose_location: 'Välj en plats',
  location_not_found: 'Vi kunde tyvärr inte hitta platsen du sökte.',
  add: 'Lägg till',
  remove: 'Ta bort',
  free_extra: 'Bonus',
  free: 'GRATIS',
  fast_track_notice: 'Den här tjänsten har begränsningar på handlingarnas ursprung. Den är bara tillgänglig för personer med handlingar från',
  complete_booking: 'Färdigställ bokning',
  choose_card: 'Välj ett kort eller lägg till ett nytt.',
  add_billing_details: 'Lägg till faktureringsuppgifter.',
  card_number: 'Kortnummer',
  card_holder_name: 'Kortinnehavarens namn',
  card_exp: 'MM/ÅÅ',
  card_cvc: 'CVC',
  save_card: 'Vill du spara kortet?',
  amount_charged: 'Ditt kort kommer att debiteras',
  payment_confirmation: 'Bekräfta bokning och betala',
  payment_methods: 'tillgängliga betalsätt',
  use_saved_card: 'x använd sparat kort',
  use_different_card: '+ använd ett annat kort',
  book_now: 'Boka nu',
  minimum_age: 'Endast personer över {age}',
  excess_liability: 'Självrisk',
  security_deposit: 'Säkerhetsdeposition',
  fuel_policy: 'Bränslepolicy',
  like_for_like: 'Lika för lika',
  full_to_full: 'Full till full',
  miles_per_rental: '{mileage} gratis miles per hyrning',
  km_per_rental: '{mileage} gratis km per hyrning',
  unlimited: 'Obegränsat',
  unlimited_mileage: 'Obegränsade miles',
  unlimited_mileage_km: 'Obegränsade km',
  non_amendable: 'Kan ej ändras',
  non_refundable: 'Kan ej återbetalas',
  free_cancellation_until: 'Gratis avbokning fram till',
  cancellation_in_line_with: 'Avbokning enligt',
  tcs: 'villkoren',
  free_extras_on_collection: 'Två bonusar vid upphämtning',
  glass_and_tyres_covered: 'Glas och däck täcks',
  number_of_passengers: 'Antal passagerare',
  number_of_bags: 'Antal väskor',
  fuel_type: 'Bränsletyp',
  co2: 'CO2',
  aircon: 'Luftkonditionering',
  book_type: 'Boka {type}',
  processing: 'Behandlar',
  actual_price: 'Faktiskt pris',
  tooltip: 'Priset i {currencyCode} är en uppskattning baserat på växelkursen. Priset i {currency} är bindande.',
  deposit: 'Deposition',
  pay_online: 'Betala online nu',
  pay_online_without_extras: 'Hyrespris',
  extras_on_arrival: 'Bonusar vid ankomst',
  insurance_on_arrival: 'Riskreducering: Betala vid ankomst',
  insurance_online: 'Riskreducering: Betala nu',
  extras_online: 'Bonusar betala nu',
  green_heart_donation: 'Greenheart-donation',
  aircon_lower: 'aircon',
  why_use_drive_and_go: 'Varför använda Drive & Go?',
  straight_to_car: 'Direkt till bilen',
  no_queues: 'Inga köer',
  self_checkout: 'Självutcheckning',
  cant_lose_key: 'Omöjligt att tappa bort nyckeln',
  online_id_check: 'Id-kontroll online',
  phone_as_key: 'Telefon som nyckel',
  premiumplus_benefits_includes: 'Premium Plus+-förmånerna inkluderar även',
  book_drive_go: 'Boka Drive & Go',
  duration: 'Varaktighet',
  to_pay_on_arrival: 'Varaktighet',
  return_date: 'Returdatum',
  postcode: 'Postnummer',
  country: 'Land',
  additional_options: 'Ytterligare alternativ',
  booking_details: 'Bokningsuppgifter',
  price_for_x_days: 'Pris för {qty_of_days} dag | Pris för {qty_of_days} dagar',
  cancelled: 'Avbruten',
  upcoming: 'Kommande',
  active: 'Aktiv',
  my_profile: 'Min profil',
  drive_and_go: {
    drive_and_go: 'Drive & Go',
    available_countries: 'Just nu är Drive & Go bara tillgängligt för de som har id- och körkortshandlingar från följande länder:',
    drive_and_go_today: 'Drive & Go-bokning idag!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Varför använda Drive & Go?',
    straight_to_car: 'Direkt till bilen',
    no_queues: 'Inga köer',
    self_checkout: 'Självutcheckning',
    cannot_lose_the_key: 'Omöjligt att tappa bort nyckeln',
    online_id_check: 'Id-kontroll online',
    phone_as_a_key: 'Telefon som nyckel',
    premium_plus_benefits_also_included: 'Premium Plus+-förmånerna inkluderar även',
    book_drive_and_go: 'Boka Drive & Go'
  },
  checkin: {
    start_check_in: 'Börja checka in',
    vehicle_location: 'Fordonsplats',
    tell_us_where_you_have_parked: 'Tala om var du parkerat fordonet.',
    fuel_and_milage: 'Bränsle och milantal',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Du bekräftar vägmätaren och bränsletanken i slutet av din hyrperiod.',
    inspect: 'Inspektera',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Vi kommer att be om fyra bilder från vart och ett av hörnen av fordonet tillsammans med eventuella nya skador som åsamkats fordonet under hyrperioden.',
    lock: 'Lås',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Kontrollera att du inte lämnat några tillhörigheter i bilen och lås den sedan.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Tala om var du parkerat fordonet.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Efter att du låst fordonet kommer du inte kunna låsa upp det igen.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, vänligen kontrollera att du inte har lämnat några tillhörigheter, lås fordonet och vid behov returnera den fysiska nyckeln till nyckelhållaren.',
    lock_vehicle: 'Lås fordonet',
    complete_check_in: 'Slutför incheckningen',
    inspection: 'Inspektion',
    complete_vehicle_check_in: 'Slutför fordonets incheckning',
    we_are_unable_to_complete_your_vehicle_check_in: 'Vi kunde inte slutföra ditt fordons incheckning',
    please_contact_customer_services: 'Kontakta kundtjänst',
    once_you_have_contacted_customer_services: 'Efter att du kontaktat kundtjänst',
    please_amend_odometer_to_be_greater_than: 'Ändra vägmätaren så att den är större än\n {odometer_value}',
  },
  checkout: {
    start_collection: 'Börja upphämtning',
    collect_vehicle: 'Hämta fordon',
    we_will_let_you_know_the_details: 'Vi kommer tala om platsen och uppgifterna så att du kan hitta hyrbilen.',
    inspect: 'Inspektera',
    we_will_ask_for_four_photos_from_each_corner: 'Vi kommer att be om fyra bilder från vart och ett av hörnen av fordonet tillsammans med eventuella nya skador som inte redan står med på listan.',
    fuel_and_milage: 'Bränsle och milantal',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Du bekräftar vägmätaren och bränsletanken i början av din hyrperiod.',
    sign: 'Skriv under',
    sign_the_rental_agreement: 'Skriv under hyresavtalet.',
    away_you_go: 'Nu är det bara att köra',
    you_are_free_to_take_to_the_road: 'Ge dig ut på vägarna!',
    collect_your_vehicle: 'Hämta ditt fordon',
    get_directions: 'Få anvisningar',
    hide_directions: 'Dölj anvisningar',
    local_time: 'lokal tid',
    tel: 'Tel',
    getting_to_the_location: 'Ta dig till platsen',
    get_vehicle_details: 'Få uppgifter om fordonet',
    view_map: 'Se karta',
    unlock_vehicle_and_continue: 'Lås upp fordonet och fortsätt',
    unable_to_connect_to_vehicle: 'Kan inte ansluta till fordonet',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Vi kunde inte ansluta dig till fordonet. Kontrollera att du står vid fordonet och försök igen.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Vi kunder inte hitta fordonets bokning. Försök igen senare.',
    odometer_and_fuel: 'Vägmätare och bränsle',
    odometer: 'Vägmätare',
    please_confirm_the_odometer_and_fuel_readings: 'Bekräfta om möjligt mätaren för kilometerteller och bränsle.',
    the_odometer_field_is_required: 'Vägmätarfältet är obligatoriskt',
    and_must_be_greater_than_the_checkout_odometer: 'och måste vara större än vägmätarantalet vid utcheckning',
    confirm: 'Bekräfta',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Ta en bild från fordonets alla hörn',
    pre_existing_damage: 'Befintlig skada',
    no_pre_existing_damage: 'Ej befintlig skada',
    new_damage: 'Ny skada',
    add_additional_damage: 'lägg till ytterligare skada',
    no_new_damage_to_report: 'Ingen ny skada att rapportera',
    checkout_complete: 'Utcheckning slutförd',
    start_rental: 'Börja uthyrningen',
    congratulations_name_it_is_time_to_take_to_the_road: 'Grattis {customer_name} det är dags att ge dig ut på vägarna!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Vi kunde inte slutföra ditt fordons utcheckning',
    please_do_the_following: 'Gör följande',
    remove_all_belonging_and_lock_the_vehicle: 'Avlägsna alla tillhörigheter och lås fordonet.',
    lock_vehicle: 'Lås fordonet',
    once_you_have_contacted_customer_services: 'Efter att du kontaktat kundtjänst',
    vehicle_location: 'Fordonets plats',
    collect_your: 'Hämta din',
    from: 'Från',
    key_in_glove_box: 'vaš ključ se nahaja v predalu za rokavice',

    keyholder: {
      not_detected: 'Nyckel upptäcks inte i nyckelhållaren',
      not_detected_please_try_again: 'Placera din nyckel i nyckelhållaren och försök sedan igen.',

      not_installed: 'Nyckelhållaren är inte installerad',
      not_installed_please_contact_customer_service: 'Nyckelhållaren är inte installerad, vänligen kontakta kundservice.',
    },
    keyring: {
      look_up_failed: 'Nyckelringens uppslag misslyckades',
      look_up_failed_please_contact_customer_service: 'Nyckelring slå upp faled, vänligen kontakta kundservice.',
    },
    key: {
      invalid: 'Nyckeln är ogiltig',
      invalid_please_contact_customer_service: 'Din nyckel är ogiltig. Kontakta kundtjänst.',

      expired: 'Nyckeln har gått ut',
      expired__please_contact_customer_service: 'Din nyckel har gått ut. Kontakta kundtjänst.',
    }
  },
  my_bookings: 'Mina bokningar',
  no_bookings: 'Inga bokningar',
  no_bookings_to_display: 'Inga bokningar att visa.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Vägmätare vid upphämtning',
  fuel_at_collection: 'Bränsle vid upphämtning',
  start_check_in: 'Starta incheckning',
  start_collection: 'Starta upphämtning',
  recent_bookings: 'Senaste bokningar',
  damage: {
    updated_damage_report_submitted: 'En uppdaterad skaderapport har skickats. Vår kundtjänst hör av sig om det behövs.',
    add_additional_damage: 'Lägg till ytterligare skador',
    you_may_report_additional_damage_up_to: 'Du kan anmäla ytterligare skador upp till 24 timmar efter att du checkat ut fordonet',
    specify_damage: 'Ange skada',
    please_choose_the_area_and_type_of_damage: 'Välj område och typ av skada',
    type_of_damage: 'Typ av skada',
    is_this_more_than_5_cm: 'Är det mer än 5 cm?',
    please_take_or_select_a_photo: 'Ta eller välj en bild',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Ta en bild och se till att skadan syns tydligt',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: 'Vid behov kan du lägga till en till bild. Väj ikonen för att lägga till en till bild',
    save_image: 'Spara bild',
    save_images: 'Spara bilder',
    damage_saved_successfully: 'Skadan har sparats',
    add_photo: 'Lägg till foto'
  },
  rental_agreement: {
    rental_agreement: 'Hyresavtal',
    agreement_between: 'Avtal mellan',
    and: 'och',
    sign_rental_agreement: 'Skriv under hyresavtal',
    i_have_read_and_understood_the_terms_and_conditions: 'Jag har läst och förstått Allmänna Villkor och accepterar fordonets villkor'
  },
  full_insurance_no_deposit: 'Full försäkring och ingen insättning krävs',
  excess: '{amount} överskott',
  deposit: '{amount} insättning',
  included_daily_distance: '{distance} {unit} per dag',
  miles: 'miles',
  kilometers: 'kilometer',
  collection_details_title: 'Samlingsdetaljer',
  collection_details_not_found: 'Inga samlingsdetaljer definierade för den här platsen',
  free_cancellation: 'fri avbokning',
  no_deposit: 'Ingen insättning',
  benefit_from: 'Dra nytta av',
  for_only_per_day: 'Endast {price} per dag',
  upgrade_mee: 'UpgradeMee'
}